"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Puff = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Puff = function Puff(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("svg", {
      width: props.width,
      height: props.height,
      viewBox: "0 0 44 44",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: props.color,
      "aria-label": props.label
    },
    /*#__PURE__*/
    _react["default"].createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      strokeWidth: "2"
    },
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "22",
      cy: "22",
      r: props.radius
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "r",
      begin: "0s",
      dur: "1.8s",
      values: "1; 20",
      calcMode: "spline",
      keyTimes: "0; 1",
      keySplines: "0.165, 0.84, 0.44, 1",
      repeatCount: "indefinite"
    }),
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "strokeOpacity",
      begin: "0s",
      dur: "1.8s",
      values: "1; 0",
      calcMode: "spline",
      keyTimes: "0; 1",
      keySplines: "0.3, 0.61, 0.355, 1",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "22",
      cy: "22",
      r: props.radius
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "r",
      begin: "-0.9s",
      dur: "1.8s",
      values: "1; 20",
      calcMode: "spline",
      keyTimes: "0; 1",
      keySplines: "0.165, 0.84, 0.44, 1",
      repeatCount: "indefinite"
    }),
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "strokeOpacity",
      begin: "-0.9s",
      dur: "1.8s",
      values: "1; 0",
      calcMode: "spline",
      keyTimes: "0; 1",
      keySplines: "0.3, 0.61, 0.355, 1",
      repeatCount: "indefinite"
    }))))
  );
};

exports.Puff = Puff;
Puff.propTypes = {
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  color: _propTypes["default"].string,
  label: _propTypes["default"].string,
  radius: _propTypes["default"].number
};
Puff.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading",
  radius: 1
};